import { useContext, useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Parser } from "html-to-react";
import { Context } from "../../../App";
import { marked } from "marked";
import Cookies from "js-cookie";

export function Warn() {
  const { statusMode } = useContext(Context);

  const [show, setShow] = useState(false);
  const [alerta, setAlerta] = useState(null);
  const markedAsReadRef = useRef(false);

  const handleClose = () => setShow(false);

  const markAsRead = async (event) => {
    const statusChecked = event.target.checked;

    if (!statusChecked || !alerta?.data?.token || markedAsReadRef.current) {
      return;
    }

    markedAsReadRef.current = true;

    const b4726486 = Cookies.get("b4726486");
    const AUTH_HEADERS = {
      Authorization: `Bearer ${b4726486}`,
      "Content-Type": "application/json",
    };

    try {
      await fetch(`https://arbitragem.bet:3131/content/alertas/marcar-lida/`, {
        method: "POST",
        headers: AUTH_HEADERS,
        body: JSON.stringify({ token: alerta.data.token }),
      });
    } catch (error) {
      // Silencia erros de rede/API na marcação como lida para não impedir a exibição
    }
  };

  useEffect(() => {
    let isMounted = true;

    async function fetchAlertaAtual() {
      const b4726486 = Cookies.get("b4726486");
      const AUTH_HEADERS = {
        Authorization: `Bearer ${b4726486}`,
        "Content-Type": "application/json",
      };
      try {
        const response = await fetch(`https://arbitragem.bet:3131/content/alertas/atual/`, {
          method: "GET",
          headers: AUTH_HEADERS,
        });

        if (response.status === 204 || response.status === 401) {
          return;
        }

        if (!response.ok) {
          return;
        }

        const data = await response.json();

        if (!isMounted) return;

        if (data?.data) {
          setAlerta(data);
          setShow(true);
        }
      } catch (error) {
        // Silencia erros de rede/API para não quebrar o componente
      }
    }

    fetchAlertaAtual();

    return () => {
      isMounted = false;
    };
  }, []);

  if (!alerta?.data) {
    return null;
  }

  const htmlContent = alerta.data.conteudo;
  const reactContent = htmlContent;
  const renderer = new marked.Renderer();

  renderer.link = ({ href, title, text }) => {
    return `<a class="link-primary" href="${href}" target="_blank" rel="noopener noreferrer">${text}</a>`;
  };

  
  marked.setOptions({
    breaks: true, // ← \n vira <br> automaticamente
    gfm: true, // ← GitHub Flavored Markdown
    headerIds: false, // ← evita IDs automáticos nos headers
    mangle: false, // ← evita warnings
    renderer,
  });
  const html111 = marked.parse(reactContent);

  return (
    <>
      <Modal
        className={`style-modal  ${
          statusMode ? "style-dark-mode" : ""
        } overflow-hidden`}
        show={show}
        onHide={handleClose}
        size="sm"
        centered
      >
        <Modal.Header
          className={`modal-header ${
            statusMode ? "style-bg-dark style-border-color style-text-gray" : ""
          }`}
          closeButton
        >
          <Modal.Title className="h4 ">
            {alerta.data.titulo || "Aviso!"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          className={`form-check text-start ${
            statusMode ? "style-text-gray style-bg-dark" : ""
          } m-0 `}
        >
          <div
            className="style-container-event"
            style={{ marginBottom: "-1.5rem" }}
          >
            <div
              className="markdown-content"
              style={{ whiteSpace: "pre-line", lineHeight: "1.5" }}
              dangerouslySetInnerHTML={{ __html: html111 }}
            />
          </div>
        </Modal.Body>
        <Modal.Footer
          className={`${
            statusMode ? "style-bg-dark style-border-color style-text-gray" : ""
          } style-container-mark-as-read`}
        >
          <div className={`form-check ps-0 m-0`}>
            <div>
              <input
                type="checkbox"
                id="mark-as-read"
                className="form-check-input ms-2"
                onChange={markAsRead}
              />
            </div>

            <label
              title="mark-as-read"
              htmlFor="mark-as-read"
              className="form-check-label ms-3"
            >
              Marcar como lida
            </label>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}
